import * as THREE from 'three'
import stone from '../../static/textures/block/stone.png'
import coal_ore from '../../static/textures/block/coal_ore.png'
import iron_ore from '../../static/textures/block/iron_ore.png'
import diamond_ore from '../../static/textures/block/diamond_ore.png'
import grass_side from '../../static/textures/block/grass_block_side.png'
import grass_top_green from '../../static/textures/block/grass_top_green.png'
import dirt from '../../static/textures/block/dirt.png'
import oak_log from '../../static/textures/block/oak_log.png'
import oak_log_top from '../../static/textures/block/oak_log_top.png'
import oak_leaves from '../../static/textures/block/oak_leaves.png'
import jungle_log from '../../static/textures/block/jungle_log.png'
import jungle_log_top from '../../static/textures/block/jungle_log_top.png'
import jungle_leaves from '../../static/textures/block/jungle_leaves.png'
import sand from '../../static/textures/block/sand.png'
import sandstone from '../../static/textures/block/sandstone.png'
import sandstone_top from '../../static/textures/block/sandstone_top.png'
import sandstone_bottom from '../../static/textures/block/sandstone_bottom.png'
import cactus_side from '../../static/textures/block/cactus_side.png'
import cactus_top from '../../static/textures/block/cactus_top.png'
import cactus_bottom from '../../static/textures/block/cactus_bottom.png'
import water from '../../static/textures/block/water.png'
import furnace_front from '../../static/textures/block/furnace_front.png'
import furnace_side from '../../static/textures/block/furnace_side.png'
import furnace_top from '../../static/textures/block/furnace_top.png'
import oak_wood from '../../static/textures/block/oak_planks.png'
import jungle_wood from '../../static/textures/block/jungle_planks.png'
import diamond from '../../static/textures/block/diamond_block.png'
import quartz from '../../static/textures/block/quartz_block_side.png'
import glass from '../../static/textures/block/glass.png'
import bedrock from '../../static/textures/block/bedrock.png'
import chest_side from '../../static/textures/block/jukebox_side.png'
import chest_top from '../../static/textures/block/jukebox_top.png'

export enum MaterialType {
  grass = 'grass',
  dirt = 'dirt',
  tree = 'tree',
  leaf = 'leaf',
  sand = 'sand',
  // water = 'water',
  stone = 'stone',
  coal = 'coal',
  wood = 'wood',
  diamond = 'diamond',
  quartz = 'quartz',
  glass = 'glass',
  bedrock = 'bedrock',
  sandstone = 'sandstone',
  cactus = 'cactus',
  jungleTree = 'jungleTree',
  jungleLeaf = 'jungleLeaf',
  jungleWood = 'jungleWood',
  water = 'water',
  ironOre = 'ironOre',
  diamondOre = 'diamondOre',
  furnace = 'furnace',
  chest = 'chest'
}
let loader = new THREE.TextureLoader()

// load texture
const grassTopMaterial = loader.load(grass_top_green)
const grassMaterial = loader.load(grass_side)
const treeMaterial = loader.load(oak_log)
const treeTopMaterial = loader.load(oak_log_top)
const dirtMaterial = loader.load(dirt)
const stoneMaterial = loader.load(stone)
const coalMaterial = loader.load(coal_ore)
const ironMaterial = loader.load(iron_ore)
const diamondOreMaterial = loader.load(diamond_ore)
const leafMaterial = loader.load(oak_leaves)
const jungleTreeMaterial = loader.load(jungle_log)
const jungleTreeTopMaterial = loader.load(jungle_log_top)
const jungleLeafMaterial = loader.load(jungle_leaves)
const sandMaterial = loader.load(sand)
const sandstoneMaterial = loader.load(sandstone)
const sandstoneTopMaterial = loader.load(sandstone_top)
const sandstoneBottomMaterial = loader.load(sandstone_bottom)
const cactusMaterial = loader.load(cactus_side)
const cactusTopMaterial = loader.load(cactus_top)
const cactusBottomMaterial = loader.load(cactus_bottom)
const waterMaterial = loader.load(water)
const furnaceFrontMaterial = loader.load(furnace_front)
const furnaceSideMaterial = loader.load(furnace_side)
const furnaceTopMaterial = loader.load(furnace_top)
const woodMaterial = loader.load(oak_wood)
const jungleWoodMaterial = loader.load(jungle_wood)
const diamondMaterial = loader.load(diamond)
const quartzMaterial = loader.load(quartz)
const glassMaterial = loader.load(glass)
const bedrockMaterial = loader.load(bedrock)
const chestSideMaterial = loader.load(chest_side)
const chestTopMaterial = loader.load(chest_top)

// pixelate texture
grassTopMaterial.magFilter = THREE.NearestFilter
grassMaterial.magFilter = THREE.NearestFilter
treeMaterial.magFilter = THREE.NearestFilter
treeTopMaterial.magFilter = THREE.NearestFilter
dirtMaterial.magFilter = THREE.NearestFilter
stoneMaterial.magFilter = THREE.NearestFilter
coalMaterial.magFilter = THREE.NearestFilter
ironMaterial.magFilter = THREE.NearestFilter
diamondOreMaterial.magFilter = THREE.NearestFilter
leafMaterial.magFilter = THREE.NearestFilter
jungleTreeMaterial.magFilter = THREE.NearestFilter
jungleTreeTopMaterial.magFilter = THREE.NearestFilter
jungleLeafMaterial.magFilter = THREE.NearestFilter
sandMaterial.magFilter = THREE.NearestFilter
sandstoneMaterial.magFilter = THREE.NearestFilter
sandstoneTopMaterial.magFilter = THREE.NearestFilter
sandstoneBottomMaterial.magFilter = THREE.NearestFilter
cactusMaterial.magFilter = THREE.NearestFilter
cactusTopMaterial.magFilter = THREE.NearestFilter
cactusBottomMaterial.magFilter = THREE.NearestFilter
waterMaterial.magFilter = THREE.NearestFilter
furnaceFrontMaterial.magFilter = THREE.NearestFilter
furnaceSideMaterial.magFilter = THREE.NearestFilter
furnaceTopMaterial.magFilter = THREE.NearestFilter
woodMaterial.magFilter = THREE.NearestFilter
jungleWoodMaterial.magFilter = THREE.NearestFilter
diamondMaterial.magFilter = THREE.NearestFilter
quartzMaterial.magFilter = THREE.NearestFilter
glassMaterial.magFilter = THREE.NearestFilter
bedrockMaterial.magFilter = THREE.NearestFilter
chestSideMaterial.magFilter = THREE.NearestFilter
chestTopMaterial.magFilter = THREE.NearestFilter

export default class Materials {
  materials = {
    grass: [
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({
        map: grassTopMaterial
      }),
      new THREE.MeshStandardMaterial({ map: dirtMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial })
    ],
    dirt: new THREE.MeshStandardMaterial({ map: dirtMaterial }),
    sand: new THREE.MeshStandardMaterial({ map: sandMaterial }),
    tree: [
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial })
    ],
    leaf: new THREE.MeshStandardMaterial({
      map: leafMaterial,
      color: new THREE.Color(0, 1, 0),
      transparent: true
    }),
    jungleTree: [
      new THREE.MeshStandardMaterial({ map: jungleTreeMaterial }),
      new THREE.MeshStandardMaterial({ map: jungleTreeMaterial }),
      new THREE.MeshStandardMaterial({ map: jungleTreeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: jungleTreeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: jungleTreeMaterial }),
      new THREE.MeshStandardMaterial({ map: jungleTreeMaterial })
    ],
    jungleLeaf: new THREE.MeshStandardMaterial({
      map: jungleLeafMaterial,
      color: new THREE.Color(0.35, 0.85, 0.25),
      transparent: true
    }),
    // water: new THREE.MeshStandardMaterial({
    //   map: waterMaterial,
    //   transparent: true,
    //   opacity: 0.7
    // }),
    stone: new THREE.MeshStandardMaterial({ map: stoneMaterial }),
    coal: new THREE.MeshStandardMaterial({ map: coalMaterial }),
    ironOre: new THREE.MeshStandardMaterial({ map: ironMaterial }),
    diamondOre: new THREE.MeshStandardMaterial({ map: diamondOreMaterial }),
    wood: new THREE.MeshStandardMaterial({ map: woodMaterial }),
    jungleWood: new THREE.MeshStandardMaterial({ map: jungleWoodMaterial }),
    diamond: new THREE.MeshStandardMaterial({ map: diamondMaterial }),
    quartz: new THREE.MeshStandardMaterial({ map: quartzMaterial }),
    glass: new THREE.MeshStandardMaterial({
      map: glassMaterial,
      transparent: true
    }),
    sandstone: [
      new THREE.MeshStandardMaterial({ map: sandstoneMaterial }),
      new THREE.MeshStandardMaterial({ map: sandstoneMaterial }),
      new THREE.MeshStandardMaterial({ map: sandstoneTopMaterial }),
      new THREE.MeshStandardMaterial({ map: sandstoneBottomMaterial }),
      new THREE.MeshStandardMaterial({ map: sandstoneMaterial }),
      new THREE.MeshStandardMaterial({ map: sandstoneMaterial })
    ],
    cactus: [
      new THREE.MeshStandardMaterial({ map: cactusMaterial }),
      new THREE.MeshStandardMaterial({ map: cactusMaterial }),
      new THREE.MeshStandardMaterial({ map: cactusTopMaterial }),
      new THREE.MeshStandardMaterial({ map: cactusBottomMaterial }),
      new THREE.MeshStandardMaterial({ map: cactusMaterial }),
      new THREE.MeshStandardMaterial({ map: cactusMaterial })
    ],
    water: new THREE.MeshStandardMaterial({
      map: waterMaterial,
      color: new THREE.Color(0.45, 0.65, 1),
      transparent: true,
      opacity: 0.62
    }),
    furnace: [
      new THREE.MeshStandardMaterial({ map: furnaceSideMaterial }),
      new THREE.MeshStandardMaterial({ map: furnaceSideMaterial }),
      new THREE.MeshStandardMaterial({ map: furnaceTopMaterial }),
      new THREE.MeshStandardMaterial({ map: furnaceTopMaterial }),
      new THREE.MeshStandardMaterial({ map: furnaceFrontMaterial }),
      new THREE.MeshStandardMaterial({ map: furnaceSideMaterial })
    ],
    bedrock: new THREE.MeshStandardMaterial({ map: bedrockMaterial }),
    chest: [
      new THREE.MeshStandardMaterial({ map: chestSideMaterial }),
      new THREE.MeshStandardMaterial({ map: chestSideMaterial }),
      new THREE.MeshStandardMaterial({ map: chestTopMaterial }),
      new THREE.MeshStandardMaterial({ map: chestTopMaterial }),
      new THREE.MeshStandardMaterial({ map: chestSideMaterial }),
      new THREE.MeshStandardMaterial({ map: chestSideMaterial })
    ]
  }

  get = (
    type: MaterialType
  ): THREE.MeshStandardMaterial | THREE.MeshStandardMaterial[] => {
    return this.materials[type]
  }
}
